import { isWebIapAvailable } from 'src/lib/iap/iap.util';
import { isPlatformNative } from 'src/lib/native/native.util';
import {
  openPopupPromise,
  PopupDialogOrigin,
} from 'src/lib/popups/popupOpenClose';
import { isPlatformGuest } from 'src/lib/utils';
import { GCInstant as platform } from 'src/lib/gcinstant';

export function openSettingsPopup(origin: PopupDialogOrigin) {
  return openPopupPromise('popupSettings', {
    origin,
    isNative: isPlatformNative(),
    hasWebIap: isWebIapAvailable(),
    isGuest: isPlatformGuest(platform),
    isDevelopment: !!process.env.IS_DEVELOPMENT,
  });
}
